import { render, staticRenderFns } from "./SquarePaymentForm.vue?vue&type=template&id=e872c702&"
import script from "./SquarePaymentForm.vue?vue&type=script&lang=ts&"
export * from "./SquarePaymentForm.vue?vue&type=script&lang=ts&"
import style0 from "./SquarePaymentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports